module.exports = __webpack_public_path__ + "img/no-drafted-job.f60f4141.svg";